import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import OrgChart from "./OrgChart";
import Navbar from "./Navbar";
import DEI from "./DEI";
import About from "./About";
import Landing from "./AltLanding";
import Methodology from "./Methodology";
import Contact from "./Contact";
import Chat from "./FullChat";
import Brown from "./Brown";
import Columbia from "./Columbia";
import Cornell from "./Cornell";
import Penn from "./Penn";
import BrownDetail from "./BrownDetail";
import ColumbiaDetail from "./ColumbiaDetail";
import CornellDetail from "./CornellDetail";
import PennDetail from "./PennDetail";

const App: React.FC = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/brown" element={<Brown />} />
        <Route path="/columbia" element={<Columbia />} />
        <Route path="/cornell" element={<Cornell />} />
        <Route path="/penn" element={<Penn />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/about" element={<About />} />
        {/*<Route path="/methodology" element={<Methodology />} />*/}
        <Route path="/" element={<Landing />} />
        <Route path="/brown/:slug" element={<BrownDetail />} />
        <Route path="/columbia/:slug" element={<ColumbiaDetail />} />
        <Route path="/cornell/:slug" element={<CornellDetail />} />
        <Route path="/penn/:slug" element={<PennDetail />} />
      </Routes>
    </Router>
  );
};

export default App;
